import AppointmentDate from './appointment-date';

export default AppointmentDate;